import { useMemo } from 'react';

import { isInvestigatorFieldAvailable } from '../../../../../../../../services/itemGroupQuestionService';

export const UPDATED_CDASH_ITEMS_COLUMN = 'UPDATED_CDASH_ITEMS_COLUMN';
export const ITEM_SEQUENCE_COLUMN = 'ITEM_SEQUENCE_COLUMN';
export const FIXED_FIELD_COLUMN = 'FIXED_FIELD_COLUMN';
export const INVESTIGATOR_FIELD_COLUMN = 'INVESTIGATOR_FIELD_COLUMN';
export const LOG_VIEW_COLUMN = 'LOG_VIEW_COLUMN';
export const FINANCE_COLUMN = 'FINANCE_COLUMN';

export function useItemGroupSetupGridConfig(domain, isLogType, hideIsTableOptions) {
  return useMemo(
    function() {
      const gridConfig = {
        columnsToShow: [FINANCE_COLUMN],
        layout: null
      };
      if (domain !== 'ICF') {
        gridConfig.columnsToShow.push(UPDATED_CDASH_ITEMS_COLUMN, ITEM_SEQUENCE_COLUMN);
      }
      if (isLogType && domain === 'AE') {
        gridConfig.columnsToShow.push(FIXED_FIELD_COLUMN);
      }
      if (isInvestigatorFieldAvailable(domain)) {
        gridConfig.columnsToShow.push(INVESTIGATOR_FIELD_COLUMN);
      }
      if (domain !== 'ICF' && !isLogType && !hideIsTableOptions) {
        gridConfig.columnsToShow.push(LOG_VIEW_COLUMN);
      }

      if (isInvestigatorFieldAvailable(domain)) {
        gridConfig.layout = 'INVESTIGATOR_FIELD';
      }

      if (!isLogType && !hideIsTableOptions) {
        gridConfig.layout = 'LEGACY_TABLE';
      }

      if (domain === 'ICF') {
        gridConfig.layout = 'ICF';
      }

      if (isLogType && domain === 'AE') {
        gridConfig.layout = 'AE_LOG';
      }

      if (['EDO', 'ECR', 'EPS'].includes(domain)) {
        gridConfig.layout = 'LEGACY_TABLE_WITHOUT_FINANCE';
        gridConfig.columnsToShow = gridConfig.columnsToShow.filter(column => column !== FINANCE_COLUMN);
      }

      return gridConfig;
    },
    [domain, isLogType, hideIsTableOptions]
  );
}
